import React from "react";
import { Box, Container, Link, Typography, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        backgroundColor: "var(--night-800)",
        color: "rgba(244, 241, 233, 0.92)",
        py: { xs: 4, md: 6 },
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
          }}
        >
          <Stack spacing={0.5}>
            <Typography
              sx={{
                fontFamily: "'IBM Plex Serif', ui-serif, Georgia, serif",
                fontWeight: 500,
                fontSize: 18,
                letterSpacing: "-0.01em",
              }}
            >
              <span style={{ fontWeight: 600 }}>micro</span>
              <span style={{ color: "#87bde0" }}>cumulus</span>
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "'IBM Plex Mono', ui-monospace, Menlo, monospace",
                fontSize: 12,
                letterSpacing: "0.04em",
                color: "rgba(244, 241, 233, 0.6)",
              }}
            >
              © {new Date().getFullYear()} · open cloud, on demand
            </Typography>
          </Stack>

          <Stack direction="row" spacing={3}>
            <Link
              component={RouterLink}
              to="/privacy"
              underline="hover"
              sx={{
                color: "#87bde0",
                fontSize: 14,
                textDecorationColor: "rgba(135, 189, 224, 0.4)",
                "&:hover": { color: "#deecf7" },
              }}
            >
              Privacy policy
            </Link>
            <Link
              component={RouterLink}
              to="/tos"
              underline="hover"
              sx={{
                color: "#87bde0",
                fontSize: 14,
                textDecorationColor: "rgba(135, 189, 224, 0.4)",
                "&:hover": { color: "#deecf7" },
              }}
            >
              Terms of service
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
